export default __webpack_public_path__ + "static/media/30inex_03.1b185f03.png";